import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AlertModalUiService } from '@ribera-web/alert-modal-ui';
import { JwtUtil } from '@ribera-web/token-decodifier-service';
import { AuthServerClockService } from './auth-server-clock.service';

@Injectable({ providedIn: 'root' })
export class SessionService {

  private router = inject(Router);
  private alertModalUiService = inject(AlertModalUiService);
  private jwtUtil = inject(JwtUtil);
  private serverClock = inject(AuthServerClockService);

  private logoutTimer: any;

  startSessionTimer(token: string) {
    this.clearTimer();

    try {
      const expiration = this.jwtUtil.getExpirationDate(token) * 1000;
      const timeout = this.serverClock.remainingMs(expiration / 1000);
      // No trusted server time on a fresh page? Let guards validate with Security MS.
      if (timeout === null) return;

      if (timeout <= 0) {
        this.logout();
        return;
      }

      this.logoutTimer = setTimeout(() => {
        this.alertModalUiService.show(
          'Por seguridad, tu sesión fue cerrada por inactividad. Por favor, inicia sesión nuevamente para continuar.',
          'info',
          'Tu sesión ha expirado',
          'Entendido',
          true,
          () => {
            this.logout();
          }
        );
      }, timeout);
    } catch (error) {
      console.error('Error starting session timer', error);
      this.logout();
    }
  }

  clearTimer() {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
    }
  }

  logout() {
    this.clearTimer();
    localStorage.removeItem('accessToken');
    sessionStorage.clear();
    this.router.navigate(['/auth/login']);
  }
}